import { MarketTemplate } from "../../data";
import { emptySelection, emptySelectionPointBox } from "../../constants";
import { Selection } from "../../contracts";

export const fillEmptyMarketSelections = (template: MarketTemplate) => {
    let selections: Selection[] = [];
    template === MarketTemplate.PointBox && selections.push({...emptySelectionPointBox});

    let counter = template === MarketTemplate.ThreeBox ? 3 : 2;

    for (let i = 0; i < counter; i++) {
        selections.push(emptySelection);
    }
    return selections;
}